import { AnalyticsEventName } from 'src/modules/analytics/models/analytics-event-name.enum';

import { SideBarMenuItemGroup } from 'src/app/models/side-bar-menu-item-group';
import { AppRouteEnum } from 'src/app/enums/app-route.enum';
import { AppFeatures } from 'src/app/enums/app-features.enum';
import { UserAccessLevelGroupName } from 'src/app/enums/user-access-level-group-name.enum';
import { SideBarMenuItem } from 'src/app/models/side-bar-menu-item';
import { practiceAdminEntryMenuItem } from 'src/app/components/side-bar/consts/practice-admin-entry.const';

export const pscHomeMenuItemsGroup: SideBarMenuItemGroup[] = [
  {
    label: 'General',
    menuItems: [
      {
        icon: 'search',
        routerLink: AppRouteEnum.PscSearch,
        name: 'PSC Search',
        hasSubNavs: true
      },
      {
        icon: 'home',
        routerLink: AppRouteEnum.PscHouseAccount,
        name: 'PSC House Account'
      },
      practiceAdminEntryMenuItem
    ]
  },
  {
    label: 'Tools',
    menuItems: [
      {
        icon: 'manifest',
        name: 'Manifest',
        accessLevelGroup: UserAccessLevelGroupName.ManifestAccessLevelGroup,
        menuItems: <SideBarMenuItem[]>[
          {
            icon: '',
            routerLink: AppRouteEnum.Manifests,
            name: 'Manifest List'
          },
          {
            icon: '',
            routerLink: [AppRouteEnum.Manifests, 'create'],
            name: 'New Manifest'
          },
          {
            icon: '',
            routerLink: AppRouteEnum.PreaccessionManifests,
            name: 'Preaccession Manifest List',
            feature: AppFeatures.PreaccessionManifests
          },
          {
            icon: '',
            routerLink: [AppRouteEnum.PreaccessionManifests, 'create'],
            name: 'New Preaccession Manifest',
            feature: AppFeatures.PreaccessionManifests
          }
        ]
      },
      {
        icon: 'price-estimator',
        routerLink: 'price-estimator',
        gaEvent: AnalyticsEventName.PriceEstimatorNavClick,
        name: 'Price Estimator'
      },
      {
        icon: 'book',
        routerLink: AppRouteEnum.TestCompendium,
        gaEvent: AnalyticsEventName.TestCompendiumNavClick,
        name: 'Test Compendium'
      },
      {
        icon: 'comment',
        routerLink: AppRouteEnum.Chat,
        name: 'Chat',
        feature: AppFeatures.Analytics
      }
    ]
  }
];
